// v10/src/hooks/useToast.js
//
// Hook para acceder al ToastProvider. Expone toast.success / toast.error /
// toast.info / toast.warning / toast.show / toast.dismiss.
//
// Si el componente no está dentro de un <ToastProvider>, devuelve un fallback
// que delega en console.warn para que el código no se rompa (defense in depth).

import { useContext } from 'react';
import { ToastContext } from '../components/common/ToastProvider';

const FALLBACK = {
  show:    (msg) => console.warn('[toast.show]',    msg),
  dismiss: () => {},
  success: (msg) => console.warn('[toast.success]', msg),
  error:   (msg) => console.warn('[toast.error]',   msg),
  info:    (msg) => console.warn('[toast.info]',    msg),
  warning: (msg) => console.warn('[toast.warning]', msg),
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  return ctx || FALLBACK;
};

export default useToast;
